import moment from "moment/moment";

export function getDateFormatted(date,format="DD-MM-yyyy"){
    return moment(date).format(format)
}

export function getFormatOraInput(data, format) {
  let moment = require("moment");
  return format ? moment(data, format).format("YYYY-MM-DD") : moment(data).format("YYYY-MM-DD");
}